export default __webpack_public_path__ + "img/partnership5-7d3f66f55d868104005b8e47e97899b7.png";